import { MoneyLinkException, ClientSystemError } from "@/shared/utils/custom-exception";
import { Timeout, TimeoutType } from "@/shared/services/http-client";

/// APIのベースクラス
export abstract class BaseApi {
  /**
   * タイムアウト値 初期値
   *
   * @protected
   * @type {TimeoutType}
   * @memberof BaseApi
   */
  protected timeout: TimeoutType = Timeout.Short;

  /**
   * パスパラメータのキー一覧
   *
   * @protected
   * @abstract
   * @type {PathParamKey[]}
   * @memberof BaseApi
   */
  protected abstract pathParamKeys: PathParamKey[];

  /**
   * パスを解決する
   *
   * @protected
   * @abstract
   * @param {{ [key: string]: string }} params
   * @returns {*}  {string}
   * @memberof BaseApi
   */
  protected abstract resolvePath(params: { [key: string]: string }): string;

  /**
   * パスパラメータの必須キーが全て渡されていることをチェックする
   *
   * @protected
   * @param {{ [key: string]: string }} params
   * @memberof BaseApi
   */
  protected ensurePathParamKeysProvided(params: { [key: string]: string }) {
    for (const pathParamKey of this.pathParamKeys) {
      if ((params[pathParamKey.key] === null || params[pathParamKey.key] === undefined) && pathParamKey.required) {
        throw new MoneyLinkException({error: ClientSystemError.Destroyed});
      }
    }
  }
}

/// パスパラメータ定義情報
export class PathParamKey {
  constructor(
    public key: string,
    public required: boolean = true // 必須かどうか。エンドポイント末尾のIDを表現するために使用している。
  ) {}

  /**
   * パスパラメータ周辺の部分的パスを解決する
   *
   * @param {{ [key: string]: string }} params
   * @memberof PathParamKey
   */
  public resolve = (params: { [key: string]: string }): string | null => {
    const value = params[this.key];

    if ((value === null || value === undefined) && this.required) {
      throw new MoneyLinkException({error: ClientSystemError.Destroyed});
    }

    if (value === null || value === undefined) {
      return null;
    }

    return value;
  };
}
